<template>
  <div class="nav-header">
    <router-link to="/partner" class="brand-logo">
      <!-- <svg class="logo-abbr" width="50" height="50" viewbox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect class="svg-logo-rect" width="50" height="50" rx="6" fill="#EB8153"></rect>
  <path class="svg-logo-path" d="M17.5158 25.8619L19.8088 25.2475L14.8746 11.1774C14.5189 9.84988 15.8701 9.0998 16.8205 9.75055L33.0924 22.2055C33.7045 22.5589 33.8512 24.0717 32.6444 24.3951L30.3514 25.0095L35.2856 39.0796C35.6973 40.1334 34.4431 41.2455 33.3397 40.5064L17.0678 28.0515C16.2057 27.2477 16.5504 26.1205 17.5158 25.8619ZM18.685 14.2955L22.2224 24.6007L29.4633 22.6605L18.685 14.2955ZM31.4751 35.9615L27.8171 25.6886L20.5762 27.6288L31.4751 35.9615Z" fill="white"></path>
</svg> -->

      <img
        src="images/logos/konferensbokarna-2.svg"
        style="width: 40px"
        alt=""
      />

      <!-- <h6 class="text-uppercase" style="font-size: 14px; padding-top: 10px;">Konferensbokarna</h6> -->
    </router-link>

    <div class="nav-control">
      <div class="hamburger">
        <span class="line"></span><span class="line"></span
        ><span class="line"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav Header",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
